import { registerBlockType } from "@wordpress/blocks";
import metadata from "./block.json";
import Save from "./save";
import Edit from "./Edit";

registerBlockType(metadata.name, {
  edit: Edit,
  save: Save,
  icon: {
    foreground: "#0061FE",
    src: (
      <svg
        id="a"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path
          d="m5.6,2.8c-2.3,0-4.2,1.9-4.2,4.2s1.9,4.2,4.2,4.2,4.3-1.9,4.3-4.2-1.9-4.2-4.3-4.2Zm0,7c-1.5,0-2.7-1.3-2.7-2.8s1.2-2.8,2.8-2.8,2.7,1.3,2.7,2.8-1.3,2.8-2.8,2.8Z"
          stroke-width="0"
        />
        <circle cx="5.6" cy="7" r="1.5" stroke-width="0" />
        <path
          d="m13.6,8.5h8c.6,0,1-.4,1-1s-.4-1-1-1h-8c-.6,0-1,.4-1,1s.5,1,1,1Zm0-1.5v.5h0v-.5Z"
          stroke-width="0"
        />
        <path
          d="m5.6,12.8c-2.3,0-4.2,1.9-4.2,4.2s1.9,4.2,4.2,4.2,4.2-1.9,4.2-4.2-1.8-4.2-4.2-4.2Zm0,7c-1.5,0-2.8-1.2-2.8-2.8s1.2-2.8,2.8-2.8,2.8,1.2,2.8,2.8-1.3,2.8-2.8,2.8Z"
          stroke-width="0"
        />
        <path
          d="m21.6,16.5h-8c-.6,0-1,.4-1,1s.4,1,1,1h8c.6,0,1-.4,1-1s-.4-1-1-1Zm-8,1h0v-.5.5Z"
          stroke-width="0"
        />
      </svg>
    ),
  },
});
